import React from "react";
import PropTypes from "prop-types";
import Auth0WebFooter from "@website-components/footer";
import { injectGlobal } from 'styled-components';

/* eslint-disable no-unused-expressions */
injectGlobal`
  footer {
    text-align: left;
  }
`;
/* eslint-enable no-unused-expressions */

const setCookie = (name, value) => {
  // eslint-disable-next-line no-undef
  document.cookie = `${name}=${value};path=/`;
};

const onChangeLang = (lang) => {
  setCookie('wclang', lang);
  // eslint-disable-next-line no-undef
  window.metricsLib.track(
    // eslint-disable-next-line no-undef
    'footer:language:changed', { category: lang }, () => document.location.reload()
  );
};

const Footer = ({footerData, theme}) =>
  <Auth0WebFooter
    data={footerData}
    oonChangeLang
    theme={theme}
    onChangeLang={onChangeLang}
  />;

Footer.defaultProps = {
  footerData: null,
  theme: "light"
};

Footer.propTypes = {
  footerData: PropTypes.shape(),
  theme: PropTypes.oneOf(['light', 'dark']),
};

export default Footer;



// WEBPACK FOOTER //
// ./src/modules/footer/Footer.js